// extracted by mini-css-extract-plugin
module.exports =  {"info":"info__2voaV","card":"card__I-u3k","spacing":"spacing__UUlAU","btn":"btn__4EQTA","modal":"modal__zk8bB"};